import React from "react";
import { formatCurrency } from "../../services/cashService";
import styles from "./DualCurrencyValue.module.scss";

// Renders a { usd, jmd } pair as two clearly labeled, color-coded chips
// instead of one "$X.XX + J$Y.YY" string jammed into a single line - used
// anywhere a register/ledger figure needs both currencies visible at once.
// `compact` lays the two chips side by side (table cells, dense rows);
// the default stacks them (stat cards, headline figures). `danger` flags
// both chips red (e.g. a register discrepancy) - a plain CSS color override
// on a wrapping element wouldn't reach the chip text, which sets its own
// color, so this has to be a real prop.
const DualCurrencyValue = ({ pair, compact = false, danger = false }) => (
    <span className={`${styles.dual} ${compact ? styles.compact : ""}`}>
        <span className={`${styles.chip} ${danger ? styles.danger : ""}`}>
            <span className={styles.chipLabel}>USD</span>
            <span className={styles.chipValue}>{formatCurrency(pair?.usd || 0, "usd")}</span>
        </span>
        <span className={`${styles.chip} ${styles.chipJmd} ${danger ? styles.danger : ""}`}>
            <span className={styles.chipLabel}>JMD</span>
            <span className={styles.chipValue}>{formatCurrency(pair?.jmd || 0, "jmd")}</span>
        </span>
    </span>
);

export default DualCurrencyValue;
